import Dashboard from "./Components/Dashboard";
import Login from "./Components/Login";
import { useState } from "react";
import "./App.css";
import Header from "./Components/Header";
import Home from "./Components/Home";
import MockTest from "./Components/MockTest";
import Result from "./Components/Result";
import PDFNotes from "./Components/PDFNotes";
import TestHistory from "./Components/TestHistory";
import { doc, getDoc, collection, getDocs, addDoc } from "firebase/firestore";
import { db } from "./firebase";
import Admin from "./Components/Admin";
function App() {
  const [startTest, setStartTest] = useState(false);
  const [testCompleted, setTestCompleted] = useState(false);
  const [score, setScore] = useState(0);
const [showLogin, setShowLogin] = useState(false);
 const [user, setUser] = useState(null);
const [isPremium, setIsPremium] = useState(false);
  const [questions, setQuestions] = useState([]);
const [questionLoadError, setQuestionLoadError] = useState("");
const [showPDF, setShowPDF] = useState(false);
const [showAdmin, setShowAdmin] = useState(false); 
  const [showHistory, setShowHistory] = useState(false);
  const [currentTestName, setCurrentTestName] = useState("free");
const startMockTest = () => {
  setShowLogin(true);
};

    const finishTest = async (finalScore, studentAnswers = {}) => {
    setScore(finalScore);
    setStartTest(false);
    setTestCompleted(true);

    if (user) {
      const total = questions.length;

      try {
        await addDoc(collection(db, "TestHistory"), {
          userId: user.uid,
          testName: currentTestName,
          score: finalScore,
          totalQuestions: total,
          correct: finalScore,
          wrong: total - finalScore,
          percentage: total
            ? Math.round((finalScore / total) * 100)
            : 0,

          questions: questions.map((q, index) => ({
            question: q.question,
            options: q.options,
            correctAnswer: q.answer,
            studentAnswer: studentAnswers[index] || "",
          })),

          expiresAt: new Date(
            Date.now() + 10 * 24 * 60 * 60 * 1000
          ),

          createdAt: new Date().toISOString(),
        });
      } catch (e) {
        console.error("History save error", e);
      }
    }
  };

  const retest = async (testName) => {
    setTestCompleted(false);
    setShowHistory(false);
    if (await loadQuestionsFromFirebase(testName || currentTestName)) {
      setStartTest(true);
    }
  };

  const dashboard = () => {
    setStartTest(false);
    setTestCompleted(false);
    setShowPDF(false);
    setShowAdmin(false);
    setShowHistory(false);
  };

  const restartTest = () => {
    setScore(0);
    setStartTest(false);
    setTestCompleted(false);
  };
const loadQuestionsFromFirebase = async (testName) => {
  try {
    setQuestionLoadError("");
    const snapshot = await getDocs(collection(db, "MockTests"));
    const seen = new Set();
    const data = snapshot.docs
      .filter((d) => d.data().test === testName)
      .map((d) => ({
        id: d.id,
        question: d.data().question,
        options: [d.data().optionA, d.data().optionB, d.data().optionC, d.data().optionD],
        answer: d.data().answer,
      }))
      .filter((q) => {
        const key = String(q.question || "").toLowerCase().replace(/\s+/g, " ").trim();
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return q.options.every(Boolean) && q.answer;
      });
    if (!data.length) {
      setQuestions([]);
      setQuestionLoadError("Is Mock Test me abhi koi valid question nahi hai. Admin Panel se questions assign/import karein.");
      return false;
    }
    setQuestions(data);
      setCurrentTestName(testName);
    return true;
  } catch (err) {
    console.error(err);
    setQuestions([]);
    setQuestionLoadError("Questions load nahi ho pa rahe. Internet/Firebase connection check karein.");
    return false;
  }
};
  const loginSuccess = async (loggedInUser) => {
  const userRef = doc(db, "users", loggedInUser.uid);
  const userSnap = await getDoc(userRef);

  let premium = false;

  if (userSnap.exists()) {
    premium = userSnap.data().premium;
  }

setUser(loggedInUser);
setIsPremium(premium);
setShowLogin(false);
setStartTest(false);
};

  return (
    <div className="App">
      <Header user={user} />
{questionLoadError && !startTest && !showLogin && (
  <div style={{maxWidth:"700px", margin:"20px auto", padding:"15px", background:"#fff3cd", borderRadius:"8px"}}>⚠️ {questionLoadError}</div>
)}
{user && !startTest && !testCompleted && !showPDF && !showAdmin && !showHistory && (
  <Dashboard
    user={user}
    isPremium={isPremium}
    onStartTest={async () => {
      if (await loadQuestionsFromFirebase("free")) setStartTest(true);
    }}
    onStartMockTest={async (testName) => {
      if (await loadQuestionsFromFirebase(testName)) setStartTest(true);
    }}
 onOpenPDF={() => setShowPDF(true)}
   onOpenAdmin={() => setShowAdmin(true)}
      onOpenHistory={() => setShowHistory(true)}
 />
)}

{!user && !startTest && !testCompleted && !showLogin && (
  <Home
    onStartTest={startMockTest}
    onLogin={() => setShowLogin(true)}
    isPremium={isPremium}
  />
)}

      {showHistory && <TestHistory user={user} onRetest={retest} onBack={dashboard} />}

{showLogin && (
  <Login onSuccess={loginSuccess} />
)}

    {startTest && (
  <MockTest
  questions={questions}
    onFinish={finishTest}
  />
)}
{showPDF && (
  <PDFNotes
    onBack={() => setShowPDF(false)}
  />
)}
     {showAdmin && (
  <Admin
    onBack={() => setShowAdmin(false)}
  />
)}
      {testCompleted && (
      <Result
        score={score}
        totalQuestions={questions.length}
        testName={currentTestName === "free" ? "Free Mock Test" : `Mock Test ${currentTestName.replace("mock", "")}`}
        onRetest={retest}
        onBack={dashboard}
      />
      )}
    </div>
  );
}

export default App;